<template>
    <!-- User Profile Card -->
    <div v-if="isOpen && selectedBot" class="mb-6 bg-zinc-800/50 rounded-xl p-4 border-white/5">
        <div class="flex items-center gap-3 mb-3">
            <div class="relative">
                <img class="max-h-[4rem]" :src="selectedBot.imageUrl" :alt="selectedBot.title">
            </div>
            <div>
                <h3 class="font-semibold text-white">{{ selectedBot.title }}</h3>
                <p class="text-xs text-zinc-400">{{ selectedBot.subtitle }}</p>
            </div>
        </div>
        
        <div class="space-y-2">
            <div class="flex justify-between items-center text-xs">
                <span class="text-zinc-400">Faturamento</span>
                <span class="text-emerald-400 font-medium">{{ progressPercentage }}%</span>
            </div>
            <div class="h-2 bg-zinc-700/50 rounded-full overflow-hidden">
                <div class="h-full bg-gradient-to-r from-emerald-500 to-teal-400 rounded-full" :style="`width: ${progressPercentage}%`"></div>
            </div>
            <div class="flex justify-between items-center text-xs">
                <span class="text-zinc-400">R$ {{ formattedCurrentAmount }}</span>
                <span class="text-zinc-400">Meta: R$ {{ formattedTargetAmount }}</span>
            </div>
            <button @click="$router.push({ name: 'awards' })" class="w-full mt-1 text-xs text-center py-1.5 rounded-md bg-zinc-700/50 hover:bg-zinc-700 text-zinc-300 transition-colors">
                Ver premiações
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watchEffect } from 'vue'

// Simulando o valor da comissão total (substitua pelo valor real do localStorage)
const totalCommissionValue = localStorage.getItem('totalCommission') || '0'
const totalCommission = ref(parseFloat(totalCommissionValue))

const awards = [
  {
    id: '1',
    title: 'Primeiro Marco',
    subtitle: 'Placa de 50K',
    imageUrl: '/img/awards/BOT - 50k.png',
    value: '50K',
    targetAmount: 50000,
    nextMilestone: '100 Mil',
    minAmount: 0,
    maxAmount: 50000
  },
  {
    id: '2',
    title: 'Mestre',
    subtitle: 'Placa de 100K',
    imageUrl: '/img/awards/BOT - 100k.png',
    value: '100K',
    targetAmount: 100000,
    nextMilestone: '500 Mil',
    minAmount: 50000,
    maxAmount: 100000
  },
  {
    id: '3',
    title: 'Elite',
    subtitle: 'Placa de 500K',
    imageUrl: '/img/awards/BOT - 500k.png',
    value: '500K',
    targetAmount: 500000,
    nextMilestone: '1 Milhão',
    minAmount: 100000,
    maxAmount: 500000
  },
  {
    id: '4',
    title: 'Lenda',
    subtitle: 'Placa de 1M',
    imageUrl: '/img/awards/BOT - 1M.png',
    value: '1M',
    targetAmount: 1000000,
    nextMilestone: '5 Milhões',
    minAmount: 500000,
    maxAmount: Infinity
  }
];

// Seleciona o prêmio adequado automaticamente
const selectedBot = ref(null)

watchEffect(() => {
  // Encontra o prêmio mais adequado baseado no valor da comissão
  const suitableAward = awards.find(award => 
    totalCommission.value >= award.minAmount && totalCommission.value < award.maxAmount
  ) || awards[awards.length - 1] // Fallback para o último prêmio se ultrapassar todos
  
  selectedBot.value = {
    ...suitableAward,
    currentAmount: totalCommission.value
  }
})

const isOpen = ref(true)

// Calcula a porcentagem de progresso
const progressPercentage = computed(() => {
  if (!selectedBot.value) return 0
  const percentage = (selectedBot.value.currentAmount / selectedBot.value.targetAmount) * 100
  return Math.min(100, percentage.toFixed(2)) // Limita a 100% e formata com 2 casas decimais
})

// Formata os valores monetários
const formattedCurrentAmount = computed(() => {
  if (!selectedBot.value) return '0,00'
  return selectedBot.value.currentAmount.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})

const formattedTargetAmount = computed(() => {
  if (!selectedBot.value) return '0,00'
  return selectedBot.value.targetAmount.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})
</script>